export default [
  {
    name: 'speakers',
    path: '/speakers',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Palestrantes',
      icon: 'dvr',
      label: 'Palestrantes',
      permission: 'speaker.list'
    }
  },
  {
    name: 'speaker-edit',
    path: '/speakers/:id/edit',
    component: () => import(/* webpackChunkName: "event" */ './Form'),
    meta: {
      showNavbar: false,
      title: 'Palestrante - Edição',
      icon: 'dvr',
      label: 'Palestrante - Edição',
      permission: 'speaker.edit'
    }
  },
  {
    name: 'speaker-new',
    path: '/speakers/novo',
    component: () => import(/* webpackChunkName: "event" */ './Form'),
    meta: {
      showNavbar: false,
      title: 'Palestrante - Adicionar',
      icon: 'dvr',
      label: 'Palestrante - Adicionar',
      permission: 'speaker.add'
    }
  }
]
